// ** Third Party Components
import { Pie } from 'react-chartjs-2';
import { Circle } from 'react-feather';

// ** Reactstrap Imports
import { Card, CardHeader, CardTitle, CardBody, Row, Col } from 'reactstrap';

const ClientsCharts = ({ data }) => {
  // ** Chart data
  const Data = {
    labels: data.clients.labels,
    datasets: [
      {
        labels: data.clients.labels,
        data: data.clients.datasets.map((item) => item.data[0]),
        backgroundColor: ['#746af0', '#f99f42', '#ea5455'],
        borderWidth: 1,
        borderColor: ['#746af0', '#f99f42', '#ea5455'],
        borderWidth: 0
      }
    ]
  };

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-sm-center align-items-start flex-sm-row flex-column">
        <CardTitle tag="h4">Clientes</CardTitle>
      </CardHeader>
      <CardBody className="px-4">
        <Row style={{ padding: 0, margin: 0 }}>
          <Col md={12}>
            <Pie data={Data} height={275} />
          </Col>
          <Col md={12}>
            <div className="d-flex justify-content-between mt-3 mb-1">
              <div className="d-flex align-items-center">
                <Circle size={17} color="#746af0" />
                <span className="fw-bold ms-75 me-25">Recurrentes</span>
              </div>
              <span>{data.totalRecurrentUsers}</span>
            </div>
            <div className="d-flex justify-content-between mb-1">
              <div className="d-flex align-items-center">
                <Circle size={17} color="#f99f42" />
                <span className="fw-bold ms-75 me-25">Nuevos</span>
              </div>
              <span>{data.totalNewsUsers}</span>
            </div>
            {/* <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center">
                <Circle size={17} color="#ea5455" />
                <span className="fw-bold ms-75 me-25">Referidos</span>
              </div>
              <span>149</span>
            </div> */}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ClientsCharts;
